module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('carousel', {
    attrs: {
      "perPageCustom": [
        [0, 1],
        [768, 2],
        [1024, 3]
      ]
    }
  }, _vm._l((_vm.socialPosts), function(post) {
    return _c('slide', [_c('div', {
      staticClass: "col-medium-1-1 social-card__container"
    }, [_c('a', {
      staticClass: "social-card",
      attrs: {
        "target": "_blank",
        "href": post.url
      }
    }, [_c('div', {
      staticClass: "social-card__media",
      style: ({
        backgroundImage: ("url(" + (post.thumb) + ")")
      })
    }, [_c('div', {
      staticClass: "social-card__media-overlay",
      style: ({
        backgroundImage: ("url(" + (post.overlay) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "social-card__media-gradient"
    })]), _vm._v(" "), _c('div', {
      staticClass: "social-card__main"
    }, [_c('h4', {
      staticClass: "social-card__title",
      domProps: {
        "innerHTML": _vm._s(post.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "social-card__content",
      domProps: {
        "innerHTML": _vm._s(post.excerpt)
      }
    })])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dc880a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/SocialCarousel.vue
// module id = 75
// module chunks = 1